export default function () {
  const externalLinks = document.querySelectorAll('a[target="_blank"]')

  externalLinks.forEach((link) => {
    link.innerHTML = `${link.innerHTML}<span class="visuallyhidden">${window.CONTENT_EXTERNAL_LINK}</span>`
  })
}
